
/*
 * Sector contact directory.
 * No React component / HoD cards are rendered from this file.
 */

export const DEFAULT_SECTOR_CONTACT = {
  email: "assocham@nic.in",
  phone: "011-46550555",
  address: [
    "ASSOCHAM HQ",
    "4th Floor, YMCA Cultural Centre and Library Building,",
    "01, Jai Singh Road,",
    "New Delhi - 110001",
  ],
  addressUrl:
    "https://www.google.com/maps?ll=28.626824,77.213067&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=12074703925506796112",
};

const createEntries = (slugs, hod, clusterHead, email, phone) =>
  Object.fromEntries(
    slugs.map((slug) => [
      slug,
      {
        hod: { name: hod, email, phone },
        clusterHead: { name: clusterHead },
      },
    ])
  );

export const SECTOR_HOD = {
  ...createEntries(
    ["agri-industries-farming-practices", "food-processing-value-addition", "pharmaceuticals", "med-tech-devices", "healthcare-wellness"],
    "Tanuja Adhikari", "D S Rajora", "tanuja.adhikari@assocham.com", "9910044086"
  ),
  ...createEntries(
    ["auto-auto-ancillaries", "green-mobility", "public-procurement", "defence-aerospace"],
    "Sumita Sharma", "D S Rajora", "sumita.shama@assocham.com", "9873379795"
  ),
  ...createEntries(
    ["msme-development-council", "exports-trade", "business-through-diplomacy", "africa-business-council", "bimstec", "eurasia"],
    "Ms. Deepti Pant", "Ms. Deepti Pant", "deepti.pant@assocham.com", "9717838540"
  ),
  ...createEntries(
    ["msme-development-council",],
    "Mr. Basudev Mukherjee", "Mr. Basudev Mukherjee", "basudev.mukherjee@assocham.com", "01146550555"
  ),
  ...createEntries(
    ["electronics-components", "animation-visual-effects-gaming-comics-avgc", "cyber-security-cyber-law", "data-centre", "digital-communication", "it-ites-digital-commerce", "fintech", "toy-council"],
    "Mr. Varun Aggarwal", "Mr. Varun Aggarwal", "varun.aggarwal@assocham.com", "9910613815"
  ),
  ...createEntries(
    ["hydropower-psp", "power-generation", "power-distribution", "power-transmission", "renewable-energy", "civil-aviation", "highway-tunnel-infrastructure"],
    "Kavita Sharma", "Dr. Ambika Sharma", "kavita.sharma@assocham.com", "9871801002"
  ),
  ...createEntries(
    ["banking", "corporate-bond-market", "insurance", "nbfcs-green-financing", "stressed-assets"],
    "Ankit Raghav", "Mr. Basudev Mukherjee", "ankit.raghav@assocham.com", "9999068767"
  ),
  ...createEntries(
    ["capital-markets", "commodity-markets-investments"],
    "Ankit Krishna", "D S Rajora", "ankit.krishna@assocham.com", "7838567953"
  ),
  ...createEntries(
    ["cfos", "direct-taxes", "indirect-taxes", "corporate-affairs-company-law-corporate-governance", "intellectual-property-rights", "legal-affairs-regulatory-reforms", "hr-ir-policies-and-reforms"],
    "Avinash Sharma", "Mr. Basudev Mukherjee", "avinash.sharma@assocham.com", "8700449266 / 9811524976"
  ),
  ...createEntries(
    ["national-council-on-education"],
    "Swati Sharma", "Dr. Ambika Sharma", "swati.sharma@assocham.com", "98995 05495"
  ),
  ...createEntries(
    ["logistics-and-warehousing", "railways-council", "real-estate-housing-and-urban-development", "sez-and-industrial-zones"],
    "Sunita Prajapati", "D S Rajora", "sunita.prajapati@assocham.com", "99999 85318"
  ),
  ...createEntries(
    ["sustainability-environment", "water"],
    "Abhay Kumar Yadav", "Dr. Ambika Sharma", "abhay.yadav@assocham.com", "9990905508"
  ),
  ...createEntries(
    ["travel-tourism-and-hospitality", "branding-marketing"],
    "Ram Kumar Vijayan", "Mr. Varun Aggarwal", "ramkumar.vijayan@assocham.com", "9873 68 8093"
  ),
  ...createEntries(
    ["manufacturing-capital-goods", "textile-technical-textile"],
    "Yashpal", "Mr. Basudev Mukherjee", "yashpal@assocham.com", "7503531087"
  ),
  ...createEntries(
    ["sustainability-environment",],
    "Ms. Alankrita Soni", "", "alankrita.soni@assocham.com", ""
  ),
  ...createEntries(
    ["chemical-petrochemicals", "mines-minerals", "iron-steel"],
    "Jaidev Sharma", "Mr. Basudev Mukherjee", "jaidev.sharma@assocham.com", "9990321148"
  ),
  ...createEntries(
    ["eodb-council"],
    "Yatika Gupta", "Mr. Basudev Mukherjee", "yatika.gupta@assocham.com", "9811523874"
  ),
  ...createEntries(
    ["startup"],
    "Manveen Chadha", "Dr. Ambika Sharma", "manveen.chadha@assocham.com", "97189 34343"
  ),
};

export function getSectorHOD(councilSlug = "") {
  return SECTOR_HOD[councilSlug] || null;
}

export function getSectorContact(councilSlug = "") {
  const assignment = getSectorHOD(councilSlug);

  return {
    hodName: assignment?.hod?.name || "ASSOCHAM Secretariat",
    clusterHeadName: assignment?.clusterHead?.name || "",
    email: assignment?.hod?.email || DEFAULT_SECTOR_CONTACT.email,
    phone: assignment?.hod?.phone || DEFAULT_SECTOR_CONTACT.phone,
    address: assignment?.hod?.address || DEFAULT_SECTOR_CONTACT.address,
    addressUrl: assignment?.hod?.addressUrl || DEFAULT_SECTOR_CONTACT.addressUrl,
  };
}
